/* Scrolling product gallery behavior (sections/product-scrolling-template.liquid).
   - Desktop: IntersectionObserver tracks which stacked media item is in view
     and highlights the matching sticky thumbnail; clicking a thumbnail scrolls
     the page to that item.
   - Mobile: builds page dots for the horizontal snap carousel and keeps them
     in sync with the scroll position.
   - Variant changes with a featured image scroll the gallery to that image.
   No dependency on Flickity/lazysizes; jQuery is used only (and optionally)
   to catch the theme's programmatic variant-select change events. */

(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 999px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function initGallery(gallery) {
    if (gallery.dataset.scrollingGalleryInit === 'true') return;
    gallery.dataset.scrollingGalleryInit = 'true';

    var list = gallery.querySelector('.scrolling-gallery__list');
    if (!list) return;

    var mediaItems = Array.prototype.slice.call(
      list.querySelectorAll('.scrolling-gallery__media')
    );
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.scrolling-gallery__thumb')
    );
    var productId = gallery.getAttribute('data-product-id');
    var dotsContainer = document.querySelector(
      '[data-scrolling-gallery-dots="' + productId + '"]'
    );

    function stickyOffset() {
      var raw = getComputedStyle(gallery).getPropertyValue('--scrolling-sticky-top');
      var parsed = parseInt(raw, 10);
      return (isNaN(parsed) ? 100 : parsed) + 10;
    }

    function scrollToIndex(index) {
      var target = mediaItems[index];
      if (!target) return;
      if (isDesktop()) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        list.scrollTo({
          left: target.offsetLeft - list.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    var dots = [];
    if (dotsContainer && mediaItems.length > 1 && dotsContainer.childElementCount === 0) {
      mediaItems.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'scrolling-gallery__dot';
        dot.setAttribute('aria-label', 'Go to item ' + (index + 1));
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          scrollToIndex(index);
        });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });
    }

    function setCurrent(index) {
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToIndex(parseInt(thumb.getAttribute('data-thumb-index'), 10));
      });
    });

    if ('IntersectionObserver' in window && mediaItems.length > 1) {
      // Vertical tracking for the desktop stacked layout
      var verticalObserver = new IntersectionObserver(
        function (entries) {
          if (!isDesktop()) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setCurrent(mediaItems.indexOf(entry.target));
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      // Horizontal tracking for the mobile snap carousel
      var horizontalObserver = new IntersectionObserver(
        function (entries) {
          if (isDesktop()) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setCurrent(mediaItems.indexOf(entry.target));
          });
        },
        { root: list, rootMargin: '0px -45% 0px -45%', threshold: 0 }
      );

      mediaItems.forEach(function (item) {
        verticalObserver.observe(item);
        horizontalObserver.observe(item);
      });
    }

    // Scroll to the variant's featured image on variant change. The theme's
    // OptionSelectors triggers 'change' on the [name="id"] select through
    // jQuery, which native listeners can't see, so bind via jQuery when
    // available and fall back to a native listener otherwise.
    var mapElement = document.querySelector(
      '[data-variant-media-map="' + productId + '"]'
    );
    var variantMediaMap = {};
    if (mapElement) {
      try {
        variantMediaMap = JSON.parse(mapElement.textContent);
      } catch (error) {
        variantMediaMap = {};
      }
    }

    function onVariantIdChange(value) {
      var mediaId = variantMediaMap[value];
      if (!mediaId) return;
      for (var i = 0; i < mediaItems.length; i++) {
        if (mediaItems[i].getAttribute('data-media-id') === String(mediaId)) {
          scrollToIndex(i);
          setCurrent(i);
          return;
        }
      }
    }

    var section = gallery.closest('.js-product-section') || document;
    if (window.jQuery) {
      window.jQuery(section).on('change', '[name="id"]', function () {
        onVariantIdChange(this.value);
      });
    } else {
      section.addEventListener('change', function (event) {
        if (event.target && event.target.name === 'id') {
          onVariantIdChange(event.target.value);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-scrolling-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
